import {
  FETCH_PROFILES,
  POST_PROFILE,
  PUT_PROFILE,
  FETCH_PROFILE
} from '../actions/profiles';

const initialState = {
  fetching: true,
  data: []
}
const profiles = (state = initialState, action) => {
  switch(action.type) {
    case `${FETCH_PROFILES}_PENDING`:
      return { ...state, fetching: true }
    case `${FETCH_PROFILES}_FULFILLED`:
      return { fetching: false, data: action.payload }
    case `${POST_PROFILE}_FULFILLED`:
      return { ...state, data: [...state.data, action.payload]}
    case `${PUT_PROFILE}_FULFILLED`:
    case `${FETCH_PROFILE}_FULFILLED`:
      return { ...state, data: state.data.map(p => p.id === action.payload.id ? action.payload : p) }
    default:
      return state;
  }
}

export default profiles;



// WEBPACK FOOTER //
// ./src/reducers/profiles.js